var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotography(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.87 11.89a4 4 0 0 0-2.35-.52.35.35 0 0 0-.34.36c0 .67 1 0 2.25.85a2.76 2.76 0 0 1 .62 3.82 3 3 0 0 1-3.75.84c-2.21-.79-2.61-3-.84-4.45l.86-.48a.31.31 0 0 0-.22-.58c-3.41 1.18-3.59 5.13-.22 6.58 5.17 2.09 7.56-4.31 3.99-6.42Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36 5.78A.35.35 0 0 0 4 5.43a9 9 0 0 0-1.4 1.32c-.83.82.52.72.68.49s1.15-1.19 1.08-1.46Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.34 9.16A.37.37 0 0 0 22 8.5a6.08 6.08 0 0 0-2.87 2.38c-.23.5.14.91.69.64 1.51-1.2.18.15 2.52-2.36Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 19.09c.31-1.07 1.32-5.6.48-7.06a1.6 1.6 0 0 0-.48-.57c-4.81-4.08-13.22-3.7-15.44-4A2.36 2.36 0 0 0 1.74 8C.61 8.92.53 11.37.25 13s-.58 5.36.69 6.4 2.92 1.25 4.4 1.76a29.72 29.72 0 0 0 7.71 1.74c.91.06 1.65.08 2.25.06 1.81-.05 2.15-.74 2.48-1.39a13.34 13.34 0 0 0 .97-2.48Zm-1.38 1.61c-.81 1.53-2.82 1.06-4.24 1a31.44 31.44 0 0 1-7.45-1.59c-1.41-.45-3-.61-4.13-1.48-.9-.7-.69-4.37-.51-5.52.29-1.93.23-4.42 1.58-4.88a45.82 45.82 0 0 1 10.24 1.28 15.19 15.19 0 0 1 5.2 2.7 1.39 1.39 0 0 1 .45.84 22.37 22.37 0 0 1-1.14 7.65Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.56 6.77c-.82-.38-7.1-2.93-8.78-2.78a.35.35 0 0 0-.08.69c.94.31 7.3 2.78 8.49 2.68 1.37.91 2.29.65 1.69 4.07-.39 2.24-.2 6-.82 6.84a11.75 11.75 0 0 1-3.72 3.45c-.38.1-.81.76-.08.68.52 0 .48-.08.88-.27a13.68 13.68 0 0 0 2.34-1.7c2.41-2.14 2.08-2.32 2.43-8.85.43-3.95-.8-3.91-2.35-4.81Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94 5.93c2.25.76 2.34.84 3.21.87a9 9 0 0 0 3.18-.54.89.89 0 0 0 .42-.61c0-.08.22-2.91.2-3a2 2 0 0 0-1.7-1.36C6.81.57 4.48 1.77 5.06 3.5c-.22.57-.66 2.24-.12 2.43Zm.79-.73c-.12-.08.18-.23.23-.91a13.58 13.58 0 0 0 5 .08l-.18 1.1c.12-.3-1.71.63-5.05-.27Zm5.11-2.28c.23.83-1.84.82-2.7.82-.09 0-2.19-.06-2.24-.58-.12-1.43 4.76-.97 4.94-.24Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.19 12a7.23 7.23 0 0 0-1.79-.2c-1 .14-.89.33-1.09 1.13s-.58 1.6.47 2.11a5.89 5.89 0 0 0 1.58.32c.36.05 1.31.52 1.75-.14.79-1.22.44-2.9-.92-3.22Zm-2.11 2.11c-.11 0-.27.16 0-1.58a7.47 7.47 0 0 1 1.82.4.72.72 0 0 1 .46.66c.17 1.24-2.19.55-2.28.52Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64 14.43a1.43 1.43 0 0 0-1-1.26c-.33 0-.48.16-.41.36s.21.75.27 1 0-.37 0 .94c-.19.63 1.04.53 1.14-1.04Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.73 14.47-.27 1.17a3.83 3.83 0 0 0 .27 1.57.31.31 0 0 0 .62 0 4 4 0 0 0 .08-2.76.35.35 0 0 0-.7.02Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotography);
export default __webpack_public_path__ + "static/media/photography.a57ffe855cc5eb8cb46b1aa11b925160.svg";
export { ForwardRef as ReactComponent };